import { apiFetch, apiFetchBlob } from './client';
import { API_BASE_URL } from '$lib/config';
import { APIError } from './errors';
import { oldCustomerInvitation, type OldCustomerDetails } from '$lib/utils/happyCode';
import type { HappyInvitation, HappyRow, HappySettings, HappyServiceSite } from './completionTypes';
import type { HappyMergeSuggestions } from './completionTypes';
import type { CareResponse } from './customerCare';
export type { HappyInvitation, HappyRow, HappySettings, HappyServiceSite } from './completionTypes';
const post = (body: unknown) => ({ method: 'POST', body: JSON.stringify(body) });
// Public calls deliberately bypass staff authentication and refresh handling.
export async function happyPublic<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(`${API_BASE_URL}/public/happy-code/${path}`, { ...post(body), headers: { 'Content-Type': 'application/json' }, credentials: 'omit' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new APIError(data.detail || 'Unable to continue. Please contact Toyama or try again.', response.status, data);
  return data as T;
}
export function inviteOldCustomer(details: OldCustomerDetails): Promise<HappyInvitation> {
  return happyPublic<HappyInvitation>('old-customer', oldCustomerInvitation(details));
}
export const queueSections = ['negatives', 'due_calls', 'feedback_pending', 'phone_mismatch', 'old_customers'] as const;
export type HappyQueue = Record<typeof queueSections[number], HappyRow[]>;
export const happyApi = {
  qr: (origin: string) => apiFetchBlob(`/admin/happy-code-settings/qr?origin=${encodeURIComponent(origin)}`),
  mergeCandidates: (id: number) => apiFetch<HappyMergeSuggestions>(`/happy-code/queue/${id}/merge-candidates`),
  settings: () => apiFetch<HappySettings>('/admin/happy-code-settings'),
  saveSettings: (settings: boolean | Partial<HappySettings>) => apiFetch<HappySettings>('/admin/happy-code-settings', { method: 'PUT', body: JSON.stringify(typeof settings === 'boolean' ? { otp_enabled: settings } : settings) }),
  queue: () => apiFetch<HappyQueue>('/happy-code/queue'),
  queueFixes: (teamId?: number, perPage = 50) => apiFetch<Pick<CareResponse, 'need_to_speak'>>(`/happy-code/queue/fixes?per_page=${perPage}${teamId === undefined ? '' : `&team_id=${teamId}`}`),
  queueSettings: () => apiFetch<HappySettings>('/happy-code/settings'),
  serviceSite: (id: number) => apiFetch<HappyServiceSite>(`/happy-code/sites/${id}`),
  action: (id: number, body: Record<string, unknown>) => apiFetch(`/happy-code/queue/${id}/action`, post(body))
};
